export default {
  id: "deep-talk-cards",
  pride: 48128,
  slug: "deep-talk-cards",
  category: "vrchat",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "Deep Talk Cards 话题世界",
    en: "Deep Talk Cards"
  },
  image: require('@/assets/images/vrc_deep_talk_cards.webp'),
  descriptionKey: {
    zh: "真心话不冒险。四类话题卡片，806 个问题，支持 EN / 日语 / 韩语 / 简繁中文。",
    en: "All the deep talk, none of the dares. Four decks, 806 questions, in EN / JP / KR / SC / TC."
  },
  date: { year: 2026, month: 2 },
  genres: ["社交", "卡牌", "多语言"],
  themes: ["真心话", "情感连接"],
  engine: "Unity (VRChat)",
  platform: ["PCVR", "Quest"],
  scale: {
    zh: "806 个问题 · EN / 日语 / 韩语 / 简繁中文",
    en: "806 questions · EN / JP / KR / SC / TC"
  },
  achievements: [
    { zh: "总访问量 90,000+ 次", en: "90,000+ Total Visits" },
    { zh: "总收藏 10,000+ 个", en: "10,000+ Total Favorites" },
    { zh: "曾冲上 VRChat 官方推荐第一名", en: "Reached #1 on VRChat Official Recommendations" }
  ],
  developerNotesKey: {
    zh: "偶然之作，原本是给一对情侣朋友的生日礼物。纯真心话卡牌社交世界，支持多语言（EN、日语、韩语、简繁中文）Quest兼容。目前依然火热，日活四五百。虽然无人反馈，但不认识的人看见我也知道我是 Deep Talk Cards 的作者。",
    en: "An accidental creation, originally a birthday gift for a couple. A pure deep-talk card social world supporting multiple languages and Quest. Still popular with 400-500 DAU. Even strangers recognize me as the author of Deep Talk Cards."
  },
  tags: ["VRChat"],
  longDescriptionKey: {
    zh: "［EN · 日本語 · 한국어 · 简繁中文］真心话不冒险。话题分为四类卡片：闲聊、过往、思辨、亲密。适合想找到共鸣的朋友、凭空起不来话题的 i 人、想增进感情的情侣。共 806 个问题，非中文语系为 AI 翻译。",
    en: "［EN · 日本語 · 한국어 · 简繁中文］All the deep talk, none of the dares. Four decks: Ice-breakers, Stories, Perspectives, and Intimacy. For friends seeking real connection, introverts who need a spark, and couples looking to grow closer. 806 questions total. Non-Chinese languages translated by AI."
  },
  links: [
    { type: "vrchat", url: "https://vrchat.com/home/world/wrld_785bc7ab-da62-4192-a8fe-830a3849467a/info", textKey: { zh: "VRChat 访问", en: "Visit in VRChat" } }
  ],
  promoUrl: 'https://tobenot.top/pr/deep-talk-cards/'
};
